import React, { useState, useEffect } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import { Box, Button, Alert, Snackbar } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, get } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import SectionHeading from "../../GRI300/GRI308/SectionHeading";
import CustomTextField from "../../GRI300/GRI308/CustomTextField";
import ReviewBox from "../../../../Components/Common/ReviewBox";

import { currentYear } from "../../../../utils/generateYearRanges";

const GRI403_4 = ({hide}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [formData, setFormData] = useState({
    workerPaticipation: "",
    healthSafetyCommitteeDetails: "",
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/gri/get?type=GRI400&Id=${id}`);
        const data = response.data.data.GRI400?.workerOHSParticipation || {};
        if (response?.data?.data?.year < currentYear - 1) setDisabled(true);

        setFormData({
          workerPaticipation: data.workerPaticipation || "",
          healthSafetyCommitteeDetails: data.healthSafetyCommitteeDetails || "",
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const handleStorage = () => {
      setGriReview(JSON.parse(localStorage.getItem("griReview")));
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const validateForm = () => {
    let newErrors = {};
    let formIsValid = true;

    if (!formData.workerPaticipation) {
      newErrors.workerPaticipation = "This field is required";
      formIsValid = false;
    }

    if (!formData.healthSafetyCommitteeDetails) {
      newErrors.healthSafetyCommitteeDetails = "This field is required";
      formIsValid = false;
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // if (!validateForm()) return;
      const payload = {
        type: "GRI400",
        workerOHSParticipation: {
          ...formData,
        },
        submitted403_4: true,
      };

      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, payload);
        navigate(`/gri/gri400/403-5/${id}`);
      } catch (error) {
        setSnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri400/403-5/${id}`);
    }
  };


  const renderContent = ({hide}) => (
    <>
      {/* <SectionHeading text="2-1 Activities, value chain and other business relationships" /> */}
      {!hide && <p className={styles.section_heading}>
        403 : Occupational Health and Safety
      </p>}
      <p className={styles.main_heading} style={{ marginBottom: hide ? "-1rem" : "0" }}>
        403-4 : Worker participation, consultation, and communication on
        occupational health and safety
      </p>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <SectionHeading text="a. Describe the procedures employed for worker participation and consultation throughout the development, implementation, and evaluation phases of the occupational health and safety management system? Additionally, please explain how the organization facilitates access to and communicates pertinent information regarding occupational health and safety to its workers." />
        <CustomTextField
          value={formData.workerPaticipation}
          onChange={(e) =>
            handleInputChange("workerPaticipation", e.target.value)
          }
          error={errors.workerPaticipation}
          helperText={errors.workerPaticipation}
          disabled={disabled}
        />

        <SectionHeading text="b. If formal joint management-worker health and safety committees are established, could you describe their roles, frequency of meetings, authority in decision-making, and rationale for any workers not being represented by these committees, if applicable?" />
        <CustomTextField
          value={formData.healthSafetyCommitteeDetails}
          onChange={(e) =>
            handleInputChange("healthSafetyCommitteeDetails", e.target.value)
          }
          error={errors.healthSafetyCommitteeDetails}
          helperText={errors.healthSafetyCommitteeDetails}
          disabled={disabled}
        />

        {/* Submit Button */}
       

        {/* Snackbar for success/error messages */}
        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  )

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
             {!griReview ? (
          <Box sx={{ ml: "1rem", width: "98%" }}>
            <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
          </Box>
        ) : (
          <Box textAlign="right" sx={{ mt: 3 }}>
            <Button
              variant="contained"
              sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
              onClick={handleSubmit}
            >
              Save & Continue <EastIcon sx={{ ml: 2 }} />
            </Button>
          </Box>
        )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI403_4;
